import { OlympiadsApi } from 'api';
import { useEffect, useState } from 'react';
import useUserData from 'hooks/useUserData';
import { Widget } from 'models/widgetMultiStageOlympiad';

export interface IDataResultOlymp {
  participantsCount: number;
  prizeholdersCount?: number;
  realCountStudent?: number;
  transitingPrizeholdersCount?: number;
}

export const useMultiStageOlympiadStore = ( widget: Widget, requestParams?: string[]) => {
  const [dataFirstOlymp, setDataFirstOlymp] = useState<IDataResultOlymp | null>(null);
  const [dataSecondOlymp, setDataSecondOlymp] = useState<IDataResultOlymp | null>(null);
  const [pending, setPending] = useState(false);

  const userData = useUserData();
  const id = userData?.id;

  useEffect(() => {
    const fetchData = async () => {
      setPending(true);
      
      try {
        if (!requestParams) return
        const results = await OlympiadsApi.getResultOlympiads(requestParams)
        const olympiads = results || [];
        const firstRound = olympiads.find((olymp) => olymp.olymp_id === widget.firstOlympId);
        const secondRound = olympiads.find((olymp) => olymp.olymp_id === widget.secondOlympId);
        
         if (firstRound) {
          setDataFirstOlymp({
            participantsCount: +firstRound.participants_count || 0,
            realCountStudent: +firstRound.real_students_count || 0,
            transitingPrizeholdersCount: +firstRound.transiting_prizeholders_count || 0,
          });
        }
        if (secondRound) {
          setDataSecondOlymp({
            participantsCount: +secondRound.participants_count || 0,
            prizeholdersCount: +secondRound.prizeholders_count || 0,
          });
        }
      } catch (error) {
        console.error(error);
      } finally {
        setPending(false);
      }
    };
    fetchData();
  }, []);

  return {
    dataFirstOlymp,
    dataSecondOlymp,
    pending,
    id,
  };
};

export type useMultiStageOlympiadStore = ReturnType<typeof useMultiStageOlympiadStore>;
